import { render, staticRenderFns } from "./timuXz.vue?vue&type=template&id=b80b9b16&scoped=true"
import script from "./timuXz.vue?vue&type=script&lang=js"
export * from "./timuXz.vue?vue&type=script&lang=js"
import style0 from "./timuXz.vue?vue&type=style&index=0&id=b80b9b16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b80b9b16",
  null
  
)

export default component.exports